import { render, staticRenderFns } from "./CampaignDashboard.vue?vue&type=template&id=02249de8&"
import script from "./CampaignDashboard.vue?vue&type=script&lang=js&"
export * from "./CampaignDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports